<template>
  <a-modal v-model:visible="computedShowModal"
           width="600px"
           :closable="false"
           :footer="null"
           :mask-closable="false"
           :mask-style="{backdropFilter: 'blur(2px)'}"
           :keyboard="false"
  >
    <div class="modal-content-body">
      <div class="search-client-header">
        <div class="modal-title">
          주최자 검색 (복수 선택 가능)
        </div>
        <button
            type="button"
            class="btn-close"
            @click="uiHandler.closeModal"
        >
          <i class="fa-regular fa-x"/>
        </button>
      </div>
      <div class="search-client-content d-flex justify-content-center flex-column align-items-center">
        <div class="search-input-container">
          <i class="fa-solid fa-magnifying-glass"/>
          <input
              type="text"
              @keyup.enter="uiHandler.search"
              v-model="searchParam.condition"
              placeholder="주최자 이름 또는 대표자명 또는 사업자번호를 입력해주세요."
          >
          <button class="search" @click="uiHandler.search">검색</button>
        </div>
        
        <!-- 선택된 주최자 표시 영역 -->
        <div class="selected-clients-container" v-if="selectedItems.length > 0">
          <div class="selected-clients-header">선택된 주최자 ({{ selectedItems.length }})</div>
          <div class="selected-clients-list">
            <div class="selected-client-item" v-for="(item, index) in selectedItems" :key="'selected-'+index">
              <span :class="['type-tag', 'type-tag-small', getOrganizerTypeClass(item.type)]">{{ getOrganizerTypeLabel(item.type) }}</span>
              <div class="selected-client-name">{{ item.organizerName }}</div>
              <button class="remove-client-btn" @click="uiHandler.removeSelectedItem(index)">
                <i class="fa-solid fa-xmark"></i>
              </button>
            </div>
          </div>
        </div>
        
        <div class="list-container">
          <div class="list-items" v-if="result.list.length > 0">
            <div
                v-for="(item, index) in result.list"
                :key="index"
                class="list-item"
                :class="item.isSelected ? 'selected' : ''"
                @click="uiHandler.toggleItemSelection(index)"
            >
              <a-typography-text :ellipsis="true" style="width: 100%;">
                <div class="item-left">
                  <span :class="['type-tag', getOrganizerTypeClass(item.type)]">{{ getOrganizerTypeLabel(item.type) }}</span>
                  {{ item.name }}<span class="cno">({{ item.convertedHospitalInfo }})</span>
                </div>
              </a-typography-text>
              <div class="item-right" v-if="item.isSelected">
                <i class="fa-solid fa-check"/>
              </div>
            </div>
          </div>
          <div
              v-else-if="loading"
              style="
                align-items: center;
                justify-content: center;
                display: flex;
                margin-top: 164px;"
          >
            <a-spin />
          </div>
          <div
              v-else
              style="
                align-items: center;
                justify-content: center;
                display: flex;
                margin-top: 164px;"
          >
            <div class="no-result">
              <div>검색 결과가 없습니다.</div>
            </div>
          </div>
        </div>
        
        <div class="pagination-container">
          <div
              v-if="loading || result.list.length === 0"
              class="page-wrapper"
          />
          <div v-else class="pagination">
            <a-pagination
              v-model:current="paginationData.currentPage"
              :total="result.totalDocs"
              :pageSize="paginationData.rowsPerPage"
              @change="uiHandler.paginationHandler"
              :hideOnSinglePage="true"
              :showSizeChanger="false"
              :showQuickJumper="false"
              :showLessItems="false"
              :showTotal="() => ''"
              :responsive="true"
            />
          </div>
        </div>
        
        <div class="modal-footer-actions">
          <button
              class="contract-cancel-btn btn-hover"
              @click="uiHandler.closeModal"
          >
            취소
          </button>
          <button
              class="contract-submit-btn btn-hover yellow-button"
              @click="uiHandler.emitClient"
          >
            선택한 주최자 적용하기
          </button>
        </div>
      </div>
    </div>
  </a-modal>
</template>
<script>
import eventsApis from '../api';

export default {
  name: 'SearchClientModal',
  emits: ['update:visible', 'select-client', 'close-modal'],
  props: {
    visible: {
      type: Boolean,
      required: true,
      default: false
    },
    initDataLoad: {
      type: Boolean,
      required: false,
      default: true
    },
    searchType: {
      type: String,
      required: false,
      default: null  // type 파라미터를 보내지 않음
    },
    initialSelectedClients: {
      type: Array,
      required: false,
      default: () => []
    }
  },
  computed: {
    computedShowModal: {
      get() {
        return this.visible;
      },
      set(value) {
        this.$emit('update:visible', value);
      }
    }
  },
  data() {
    return {
      uiHandler: null,
      loading: false,
      searchParam: {
        condition: ''
      },
      paginationData: {
        rowsPerPage: 10,
        currentPage: 1,
        totalPages: 0,
      },
      selectedItems: [], // 선택된 주최자 목록 배열
      result: {
        list: [],
        totalDocs: 0,
      },
      apiInstance: null,
    }
  },
  created() {
    this.uiHandler = this.createUIHandler();
    
    // API 인스턴스 초기화
    this.apiInstance = eventsApis(this.$apiInstance, this.$store);
    
    // 초기 선택된 주최자가 있으면 선택된 아이템 목록에 추가
    if (this.initialSelectedClients && this.initialSelectedClients.length > 0) {
      // 필드명이 이미 백엔드 스키마에 맞게 되어 있는지 확인하고, 필요하면 변환
      this.selectedItems = this.initialSelectedClients.map(client => {
        if (client.organizerName) {
          // 이미 백엔드 스키마 형식이면 그대로 사용
          return client;
        } else {
          // 기존 형식이면 변환 (id가 _id에 해당)
          return {
            organizerId: String(client.id || client._id),
            organizerName: client.name,
            representative: client.representative || '',
            organizerCno: client.businessNumber || '',
            directInput: client.isCustom || false
          };
        }
      });
    }
  },
  mounted() {
    if (this.initDataLoad) {
      this.uiHandler.getClientList();
    }
  },
  watch: {
    visible(newVal) {
      if (newVal === true) {
        // 모달이 열릴 때 주최자 목록 검색
        this.searchParam.condition = '';
        this.paginationData.currentPage = 1;
        this.uiHandler.getClientList();
      }
    },
    initialSelectedClients: {
      handler(newVal) {
        if (newVal && newVal.length > 0) {
          // 필드명이 이미 백엔드 스키마에 맞게 되어 있는지 확인하고, 필요하면 변환
          this.selectedItems = newVal.map(client => {
            if (client.organizerName) {
              // 이미 백엔드 스키마 형식이면 그대로 사용
              return client;
            } else {
              // 기존 형식이면 변환 (id가 _id에 해당)
              return {
                organizerId: String(client.id || client._id),
                organizerName: client.name,
                representative: client.representative || '',
                organizerCno: client.businessNumber || '',
                directInput: client.isCustom || false
              };
            }
          });
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    // 사업자번호 포맷팅 함수
    businessNumberFormatter(value) {
      if (!value) return '';
      value = value.replace(/[^0-9]/g, '');
      return value.replace(/(\d{3})(\d{2})(\d{5})/, '$1-$2-$3');
    },

    // 주최자 유형을 한글 라벨로 변환
    getOrganizerTypeLabel(type) {
      const typeLabels = {
        'HOSPITAL': '병원',
        'MANUFACTURER': '제조사',
        'CUSTOM': '직접입력'
      };
      return typeLabels[type] || type || '병원';
    },

    // 주최자 유형에 따른 태그 CSS 클래스
    getOrganizerTypeClass(type) {
      const typeClasses = {
        'HOSPITAL': 'type-tag-hospital',
        'MANUFACTURER': 'type-tag-manufacturer',
        'CUSTOM': 'type-tag-custom'
      };
      return typeClasses[type] || 'type-tag-hospital';
    },
    
    createUIHandler() {
      // UI 관련 핸들러 생성
      return {
        // 페이지네이션 이벤트 핸들러
        paginationHandler: (page) => {
          this.paginationData.currentPage = page;
          this.getClientList();
        },
        
        // 주최자 정보 텍스트 조합
        joinHospitalInfo: (item) => {
          const array = [
            item.representative,
            this.businessNumberFormatter(item.businessNumber || item.organizerCno),
          ];

          if (item.address) array.push(item.address);

          return array.join(', ');
        },

        // 아이템 선택 토글
        toggleItemSelection: (index) => {
          const item = this.result.list[index];
          
          // 이미 선택된 거래처인지 확인
          const alreadySelectedIndex = this.selectedItems.findIndex(
            selected => selected.organizerId === String(item.id)
          );
          
          // 선택 상태 토글
          if (alreadySelectedIndex >= 0) {
            // 이미 선택된 경우 선택 해제
            this.selectedItems.splice(alreadySelectedIndex, 1);
            item.isSelected = false;
          } else {
            // 선택되지 않은 경우 선택 (백엔드 스키마에 맞게 필드명 변환)
            this.selectedItems.push({
              organizerId: String(item.id), // item.id는 실제로 _id 값임
              organizerName: item.name,
              type: item.type || 'HOSPITAL', // API 응답의 type 필드 사용
              representative: item.representative || item.ceo || '',
              organizerCno: item.businessNumber || item.cNo || '',
              directInput: false
            });
            item.isSelected = true;
          }
        },
        
        // 선택된 아이템 제거
        removeSelectedItem: (index) => {
          const removedItem = this.selectedItems[index];
          this.selectedItems.splice(index, 1);
          
          // 현재 리스트에서도 체크 해제
          const listIndex = this.result.list.findIndex(item => String(item.id) === removedItem.organizerId);
          if (listIndex >= 0) {
            this.result.list[listIndex].isSelected = false;
          }
        },
        
        // 검색 실행
        search: () => {
          this.paginationData.currentPage = 1;
          this.getClientList();
        },
        
        // 선택된 주최자 유효성 검사 및 확인
        validateData: () => {
          if (this.selectedItems.length === 0) {
            this.$message ? 
              this.$message.warning('최소 한 개 이상의 주최자를 선택해 주세요.') : 
              alert('최소 한 개 이상의 주최자를 선택해 주세요.');
            return { status: false };
          }
          
          // 항목들이 모두 백엔드 스키마 필드명에 맞게 변환되어 있는지 확인
          const validSelectedItems = this.selectedItems.map(item => {
            if (item.organizerName) {
              return item;
            } else {
              return {
                organizerId: String(item.id || item._id),
                organizerName: item.name,
                type: item.type || 'HOSPITAL',
                representative: item.representative || item.ceo || '',
                organizerCno: item.businessNumber || item.cNo || '',
                directInput: item.isCustom || false
              };
            }
          });

          return { status: true, selectedItems: validSelectedItems };
        },
        
        // 선택한 거래처 전달
        emitClient: () => {
          const result = this.uiHandler.validateData();
          if (!result.status) return;
          
          // 이미 selectedItems가 백엔드 스키마에 맞는 필드명으로 변환되어 있으므로 직접 전달
          this.$emit('select-client', result.selectedItems);
          this.computedShowModal = false;
        },
        
        // 모달 닫기
        closeModal: () => {
          this.$emit('close-modal');
          this.computedShowModal = false;
        },
        
        // 주최자 목록 조회
        getClientList: () => {
          this.getClientList();
        }
      };
    },
    
    // 주최자 목록 조회 API 호출 함수
    getClientList() {
      if (!this.apiInstance) {
        console.error('API 인스턴스가 초기화되지 않았습니다.');
        return;
      }
      
      this.loading = true;
      
      // 검색 파라미터 구성
      const params = {
        page: this.paginationData.currentPage,
        limit: this.paginationData.rowsPerPage,
        search: 'name',
        condition: this.searchParam.condition
        // type 파라미터 제거 - 신규 API는 type 없이 모든 주최자 조회
      };
      
      // API 호출 (통합 주최자 검색 엔드포인트 사용)
      this.apiInstance.getOrganizerList(
        params,
        (response) => {
          const responseData = response.data;
          
          // 페이지네이션 정보 설정
          this.result.totalDocs = responseData.totalDocs || 0;
          this.paginationData.totalPages = responseData.totalPages || 0;
          
          // 결과 목록에 추가 정보 설정
          this.result.list = (responseData.docs || []).map(item => {
            // 이미 선택된 아이템인지 확인
            const isAlreadySelected = this.selectedItems.some(
              selected => selected.organizerId === String(item._id)
            );

            // 주소 정보 조합
            const address = item.addrOne && item.addrTwo 
              ? `${item.addrOne} ${item.addrTwo}${item.addrDetail ? ' ' + item.addrDetail : ''}`
              : (item.bizAddr || '');
            
            return {
              id: item._id,
              _id: item._id, // 원본 _id 값도 유지
              name: item.name,
              type: item.type || 'HOSPITAL', // API 응답의 type 필드 보관
              representative: item.representative || item.ceo || '',
              businessNumber: item.businessNumber || item.cNo || '',
              ceo: item.ceo || '', // API 응답의 ceo 필드 보관
              cNo: item.cNo || '', // API 응답의 cNo 필드 보관
              address: address,
              convertedHospitalInfo: this.uiHandler.joinHospitalInfo({
                representative: item.representative || item.ceo || '',
                businessNumber: item.businessNumber || item.cNo || '',
                address: address
              }),
              isSelected: isAlreadySelected
            };
          });
          
          this.loading = false;
        },
        (error) => {
          console.error('거래처 목록 조회 실패:', error);
          this.$message?.error('거래처 목록을 불러오는 중 오류가 발생했습니다.');
          this.result.list = [];
          this.result.totalDocs = 0;
          this.paginationData.totalPages = 0;
          this.loading = false;
        }
      );
    }
  }
};
</script>
<style scoped lang="scss">
.modal-content-body {
  padding: 16px;
  position: relative;
  height: 640px;
  display: flex;
  flex-direction: column;
}

.search-client-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.search-client-content {
  flex: 1;
  overflow: hidden;
  position: relative;
}

.modal-title {
  font-size: 18px;
  font-weight: bold;
}

.btn-close {
  background: transparent;
  border: none;
  cursor: pointer;
  font-size: 16px;
}

.search-input-container {
  position: relative;
  width: 100%;
  margin-bottom: 20px;
  
  i {
    position: absolute;
    left: 12px;
    top: 50%;
    transform: translateY(-50%);
    color: #999;
  }
  
  input {
    width: 100%;
    height: 40px;
    padding: 8px 110px 8px 38px;
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    background: #f9fafb;
    
    &:focus {
      outline: none;
      border-color: #FFCC32;
    }
  }
  
  button.search {
    position: absolute;
    right: 0px;
    top: 50%;
    transform: translateY(-50%);
    background-color: #FFCC32;
    color: #000;
    border: none;
    border-radius: 4px;
    padding: 6px 15px;
    cursor: pointer;
    font-weight: 500;
    
    &:hover {
      background-color: #E6B82E;
    }
  }
}

/* 선택된 거래처 영역 스타일 */
.selected-clients-container {
  width: 100%;
  margin-bottom: 16px;
  padding: 12px;
  background-color: #f9f9f9;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
}

.selected-clients-header {
  font-size: 14px;
  font-weight: 500;
  color: #555;
  margin-bottom: 8px;
}

.selected-clients-list {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.selected-client-item {
  display: flex;
  align-items: center;
  background-color: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 20px;
  padding: 4px 12px;
  gap: 8px;
}

.selected-client-name {
  font-size: 13px;
}

.remove-client-btn {
  background: none;
  border: none;
  cursor: pointer;
  padding: 2px;
  font-size: 12px;
  color: #999;
  display: flex;
  align-items: center;
  justify-content: center;
  
  &:hover {
    color: #f56c6c;
  }
}

.list-container {
  width: 100%;
  height: 300px;
  overflow-y: auto;
  margin-bottom: 12px;
}

.list-items {
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  overflow: hidden;
}

.list-item {
  padding: 12px 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #e5e7eb;
  cursor: pointer;
  transition: background-color 0.2s;
  
  &:last-child {
    border-bottom: none;
  }
  
  &:hover {
    background-color: #f5f5f5;
  }
  
  &.selected {
    background-color: #FFCC32;
  }
}

.item-left {
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 8px;

  .cno {
    font-weight: normal;
    color: #666;
    margin-left: 8px;
    font-size: 0.9em;
  }
}

/* 주최자 유형 태그 스타일 */
.type-tag {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 500;
  white-space: nowrap;
  flex-shrink: 0;
}

.type-tag-small {
  padding: 1px 6px;
  font-size: 10px;
}

.type-tag-hospital {
  background-color: #e6f7ff;
  color: #1890ff;
  border: 1px solid #91d5ff;
}

.type-tag-manufacturer {
  background-color: #fff7e6;
  color: #fa8c16;
  border: 1px solid #ffd591;
}

.type-tag-custom {
  background-color: #f6ffed;
  color: #52c41a;
  border: 1px solid #b7eb8f;
}

.item-right {
  color: #fff;
}

.page-wrapper {
  height: 40px;
  margin-top: 16px;
}

.pagination-container {
  width: 100%;
  margin-top: 8px;
  margin-bottom: 16px;
  
  .pagination {
    display: flex;
    justify-content: center;
    
    :deep(.ant-pagination) {
      display: flex;
      align-items: center;
      
      .ant-pagination-item {
        border: none;
        background: transparent;
        margin: 0 8px;
        min-width: 32px;
        height: 32px;
        line-height: 32px;
        
        a {
          color: #333;
          padding: 0;
          display: flex;
          align-items: center;
          justify-content: center;
          width: 100%;
          height: 100%;
        }
        
        &.ant-pagination-item-active {
          background-color: #FFCC32;
          border-radius: 50%;
          
          a {
            color: #000;
            font-weight: 500;
          }
        }
        
        &:hover {
          a {
            color: #FFCC32;
          }
        }
      }
      
      .ant-pagination-prev, 
      .ant-pagination-next,
      .ant-pagination-jump-prev, 
      .ant-pagination-jump-next {
        margin: 0 8px;
        min-width: 32px;
        height: 32px;
        line-height: 32px;
        border: none;
        
        .ant-pagination-item-link {
          border: none;
          background: transparent;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 14px;
          color: #666;
          
          &:hover {
            color: #FFCC32;
          }
        }
      }
      
      .ant-pagination-options {
        display: none;
      }
    }
  }
}

.modal-footer-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding: 16px 0 0;
  width: 100%;
  border-top: 1px solid #f0f0f0;
}

.contract-cancel-btn {
  padding: 6px 16px;
  background-color: #f0f0f0;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  cursor: pointer;
  
  &:hover {
    background-color: #e0e0e0;
  }
}

.contract-submit-btn {
  padding: 6px 16px;
  background-color: #FFCC32;
  border: 1px solid #FFCC32;
  border-radius: 4px;
  color: #000;
  font-weight: 500;
  cursor: pointer;
  
  &:hover {
    background-color: #E6B82E;
    border-color: #E6B82E;
  }
}

.yellow-button {
  background-color: #FFCC32 !important;
  border-color: #FFCC32 !important;
  color: #000 !important;
  
  &:hover {
    background-color: #E6B82E !important;
    border-color: #E6B82E !important;
  }
  
  &:disabled {
    background-color: #d9d9d9 !important;
    border-color: #d9d9d9 !important;
    color: rgba(0, 0, 0, 0.25) !important;
  }
}

.no-result {
  color: #999;
  text-align: center;
  padding: 20px;
  font-size: 14px;
}
</style>
